module.exports = __webpack_public_path__ + "img/km_17.f13d1d1c.jpeg";